export enum SelectedGender{
    male,
    women,
    male_women_diff
  }